// src/App.js

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
  import "./styles/design-tokens.css";
import "./styles/shared.css";

import { useAuth } from './AuthContext';
import Header from "./components/Header";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Recherche from "./pages/Recherche";
// Import des pages
import Section from "./pages/Section";
import Brevehistoire from "./pages/Brevehistoire";
import Connexion from "./pages/Connexion";
import Dictionnaire from "./pages/Dictionnaire";
import Elementsdegrammaire from "./pages/Elementsdegrammaire";
import Identification from "./pages/Identification";
import Signesabreviations from "./pages/Signesabreviations";
import ForgotPassword from "./pages/ForgotPassword";
import ErrorPage from "./pages/ErrorPage";

// Import des chapitres de l'histoire
import H1_Introduction from './pages/histoire/H1_Introduction';
import H2_Royaumes from './pages/histoire/H2_Royaumes';
import H3_Europeens from './pages/histoire/H3_Europeens';
import H4_Conclusion from './pages/histoire/H4_Conclusion';
import H5_Annexes from './pages/histoire/H5_Annexes';

function App() {
  const { isLoading } = useAuth();

  // Disable copy, cut, paste, and right-click context menu
  React.useEffect(() => {
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    const handleCut = (e) => {
      e.preventDefault();
      return false;
    };

    const handlePaste = (e) => {
      e.preventDefault();
      return false;
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    document.addEventListener('copy', handleCopy);
    document.addEventListener('cut', handleCut);
    document.addEventListener('paste', handlePaste);
    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('cut', handleCut);
      document.removeEventListener('paste', handlePaste);
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  if (isLoading) {
    return <div>Chargement de l'application...</div>;
  }

  return (
    // Ce conteneur va gérer la disposition de toute la page
    <div className="app-container">
      <Header />
      
      {/* Ce conteneur va s'étirer pour pousser le footer en bas */}
      <main className="main-content">
        <Routes>
          {/* Routes Publiques */}
          <Route path="/" element={<Section />} />
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/identification" element={<Identification />} />
          <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
          
          {/* Route protégée principale pour l'histoire */}
          <Route 
            path="/brevehistoire" 
            element={<ProtectedRoute><Brevehistoire /></ProtectedRoute>}
          >
            <Route index element={<Navigate to="introduction" replace />} /> 
            <Route path="introduction" element={<H1_Introduction />} />
            <Route path="royaumes" element={<H2_Royaumes />} />
            <Route path="europeens" element={<H3_Europeens />} />
            <Route path="conclusion" element={<H4_Conclusion />} />
            <Route path="annexes" element={<H5_Annexes />} />
          </Route>

          {/* ... (vos autres routes protégées) ... */}
          <Route path="/recherche" element={<ProtectedRoute><Recherche /></ProtectedRoute>} />
          <Route path="/dictionnaire" element={<ProtectedRoute><Dictionnaire /></ProtectedRoute>} />
          <Route path="/elementsdegrammaire" element={<ProtectedRoute><Elementsdegrammaire /></ProtectedRoute>} />
          <Route path="/signesabreviations" element={<ProtectedRoute><Signesabreviations /></ProtectedRoute>} />

          {/* Route 404 - Doit toujours être en dernier */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </main>
      
      <Footer />
    </div>
  );
}

export default App;